var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attribute)?_c('div',{staticClass:"gmb-attribute-item"},[_c('GmbAttributeChip',{attrs:{"name":_vm.attribute.displayName,"value":_vm.attribute.value,"delete-mode":_vm.deleteMode},on:{"input":_vm.selectValue}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }